<template>
  <v-menu
    v-if="isAuth"
    offset-y
    left
    v-model="menu"
    class="relative z-[9999999] bg-[#3C50E0]"
    max-width="300px"
  >
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        flat
        :width="isMobile ? '40px' : '300px'"
        :disabled="isLoading"
      >
        <v-skeleton-loader
          v-if="isLoading"
          type="list-item-avatar"
        ></v-skeleton-loader>
        <user-logo
          :size="40"
          v-else-if="isMobile"
          :user="selectedUser"
        ></user-logo>
        <v-list-item v-else>
          <!-- Use v-if with a computed property to conditionally show user logo and name -->
          <div v-if="showUserLogoAndName" class="flex jus">
            <v-list-item-avatar
              class="cursor-pointer"
              style="margin-right: -10px"
            >
              <user-logo :size="40" :user="selectedUser"></user-logo>
            </v-list-item-avatar>
            <!-- <v-list-item-content>
              <div>
                <v-list-item-title>{{
                  selectedUser.display_name
                }}</v-list-item-title>
              </div>
              <v-list-item-subtitle class="caption">{{
                selectedUser.email
              }}</v-list-item-subtitle>
            </v-list-item-content> -->
          </div>

          <!-- <v-list-item-avatar>
            <v-icon class="drop">mdi-chevron-down</v-icon>
          </v-list-item-avatar> -->
        </v-list-item>
      </div>
    </template>
    <v-list class="pt-0">
      <v-divider class="mb-2"></v-divider>
      <div class="flex p-6">
        <v-list-item-avatar
          @click="$router.replace('/edit-profile')"
          class="cursor-none"
        >
          <user-logo :size="40" :user="selectedUser"></user-logo>
        </v-list-item-avatar>
        <v-list-item-content
          @click="$router.replace('/edit-profile')"
          class="cursor-pointer"
        >
          <div
            class="text-neutral-900 text-lg font-medium font-['Poppins'] flex items-center"
          >
            <span>{{ selectedUser.display_name }}</span>
            <v-icon class="ml-2" small>mdi-pencil</v-icon>
          </div>
          <div class="text-slate-500 text-xs font-normal font-['Poppins'] overflow-visible whitespace-normal break-words w-full">
            {{ selectedUser.email }}
          </div>
        </v-list-item-content>
      </div>

      <div class="w-[347px] h-[0px] border-2 border-slate-100"></div>
      <!-- <v-list-item dense @click="$router.replace('/edit-profile')" class="my-2">
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-3">
            <img loading="lazy" src="@/assets/img/mgr.svg" />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Manage Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->

      <!-- <v-list-item dense @click="$router.replace('/account')" class="my-2">
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-3">
            <img loading="lazy" src="@/assets/img/mgacc.svg" />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Manage Account</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item dense @click="$router.replace('/team')" class="my-2">
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-3">
            <img
              class="w-[22px] h-[22px] -ml-1"
              loading="lazy"
              src="@/assets/img/team.svg"
            />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Manage Team</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="$router.replace('/subscription')">
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-2">
            <img loading="lazy" src="@/assets/img/subs.svg" />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Subscription</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="$router.replace('/api-key-gen')" class="my-2">
        <div class="w-[31px] h-[32px] bg-slate-100 rounded-full">
          <div class="relative">
            <img
              loading="lazy"
              src="@/assets/img/fly-api/icons8-rest-api-50.png"
            />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">API Access</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="isConfigCreated"
        dense
        @click="$router.replace('/api-key-gen')"
        class="my-2"
      >
        <div class="w-[35px] h-[35px] bg-slate-100 rounded-full">
          <div class="relative">
            <img
              loading="lazy"
              src="@/assets/img/fly-api/icons8-administrative-tools-80.png"
            />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Create New Config</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="isSuperAdmin"
        dense
        @click="$router.replace('/generate-access-token')"
        class="my-2"
      >
        <div class="w-[35px] h-[35px] bg-slate-100 rounded-full">
          <div class="relative">
            <img
              loading="lazy"
              src="@/assets/img/fly-api/icons8-administrative-tools-80.png"
            />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Generate Access Token</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item dense @click="$router.replace('/terms-of-use')" class="my-2">
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-2">
            <img loading="lazy" src="@/assets/img/terms.svg" />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Terms of use</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <!-- <v-list-item
        dense
        @click="$router.replace('/privacy-policy')"
        class="my-2"
      >
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-2">
            <img loading="lazy" src="@/assets/img/privacy.svg" />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Privacy Policy</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item dense @click="open()" class="my-2">
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-2">
            <img loading="lazy" src="@/assets/img/sup.svg" />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Support</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="$router.replace('/feedback')" class="my-2">
        <div class="w-[37px] h-[37px] bg-slate-100 rounded-full">
          <div class="relative top-2 left-2">
            <img loading="lazy" src="@/assets/img/bulb.svg" class="w-6 h-6" />
          </div>
        </div>
        <v-list-item-content>
          <v-list-item-title class="ml-4">Feedback</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item dense @click="logout()">
        <v-list-item-avatar size="20">
          <v-icon>mdi-location-exit</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <div class="flex justify-end mr-2">
        <v-btn
          :loading="loading"
          text
          class="w-[114px] h-[39px] bg-[#3C50E0] rounded-[32px]"
          color="white"
          @click="logout()"
          ><span class="text-xs font-medium text-white">Logout</span></v-btn
        >
      </div>
      <!-- Display the app version -->
      <div class="ml-4 app-version">[ {{ getVersion() }} ]</div>
    </v-list>
  </v-menu>
</template>

<script>
import { onAuthStateChanged, signOut } from "firebase/auth";
import UserLogo from "./UserLogo.vue";
import { auth, colUsers, db } from "@/utils/firebase.utils";
import {
  doc,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
  where,
  collection,
  getDocs,
  addDoc,
} from "firebase/firestore";

export default {
  components: { UserLogo },
  data() {
    return {
      users: [],
      menu: false,
      subscribe: null,
      isLoading: false,
      loading: false,
      isConfigCreated: false,
      isSuperAdmin: false,
      currentUserId: null,
    };
  },
  computed: {
    showUserLogoAndName() {
      return window.innerWidth > 480;
    },
    selectedUser() {
      let user = this.users.find((i) => i.id == this.currentOriginalUID);
      return user || this.authUser;
    },
  },
  methods: {
    navigateToFeedback() {
      window.open("https://fly-social.canny.io/feature-requests", "_blank");
    },
    getVersion() {
      if (process.env.VUE_APP_ENV === "production") {
        return process.env.VUE_APP_VERSION;
      } else {
        return process.env.VUE_APP_ENV + "-" + process.env.VUE_APP_VERSION;
      }
    },
    open() {
      if (window.Intercom) {
        window.Intercom("show");
      } else if ($zoho) {
        // Fallback or alternative if Intercom is not available
        $zoho.salesiq.floatwindow.visible("show");
      }
    },
    async checkConfigAndAdminStatus() {
      let userApiRef = collection(
        db,
        "users_api_key",
        this.currentUID,
        "configurations"
      );
      let userRef = doc(
        db,
        "users",
        this.currentUID
      );

      try {
        const snapshot = await getDocs(userApiRef);
        if (snapshot.empty || snapshot.docs.length === 0) {
          // Skipping to Create New Config in Dropdown
        } else {
          this.isConfigCreated = true;
        }

        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          if ('super_admin' in userData && userData.super_admin) {
              this.isSuperAdmin = true;
          } else {
            this.isSuperAdmin = false;
          }
        }

      } catch (error) {
        console.error("Error checking documents:", error);
      }
    },
    async logout() {
      if (!auth.currentUser) {
        console.warn("No authenticated user found during logout");
        return;
      }

      let uid = auth.currentUser.uid;
      const loginSessionRef = collection(db, "fly_login_sessions");
      const loginSessionData = {
        uid: uid,
        created_at: new Date(),
        origin_url: window.location.hostname,
        action: "logout",
      };
      addDoc(loginSessionRef, loginSessionData);
      this.$store.commit("SET_AUTH", false);
      this.users = [];
      this.$mixpanel.track("User Logged Out");
      this.$mixpanel.reset();
      await signOut(auth);
      this.$router.replace("/login");
      localStorage.clear();
      sessionStorage.clear();
    },
    changeUser(user) {
      if (!user || !user.id) {
        console.warn("Invalid user data in changeUser");
        return;
      }

      this.$store.commit("SET_CURRENT_UID", user.id);
      this.$store.commit("SET_CURRENT__ORIGINAL_UID", user.id);
      this.$store.commit("SET_CURRENT_USER", user);

      if (this.currentUserId) {
        updateDoc(doc(colUsers, this.currentUserId), {
          default_uid: user.id,
        }).catch((error) => {
          console.error("Error updating user default_uid:", error);
        });
      }
    },
    async listenUsers() {
      const vm = this;
      vm.isLoading = true;

      if (!auth || !auth.currentUser) {
        console.warn("Auth or currentUser is not available");
        vm.isLoading = false;
        return;
      }

      const currentUID = vm.authUser?.default_uid || auth.currentUser.uid;
      if (!currentUID) {
        console.warn("No currentUID available");
        vm.isLoading = false;
        return;
      }

      try {
        const userDocRef = doc(colUsers, currentUID);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const user = { ...userDocSnap.data(), id: userDocSnap.id };
          vm.users = [user];
          vm.$store.commit("SET_CURRENT_UID", user.id);
          vm.$store.commit("SET_CURRENT__ORIGINAL_UID", user.id);
          vm.$store.commit("SET_CURRENT_USER", user || vm.authUser);
        } else {
          console.warn("User document does not exist for uid:", currentUID);
        }
      } catch (error) {
        console.error("Error in listenUsers:", error);
        vm.handleError(error);
      } finally {
        vm.isLoading = false;
      }
    },
  },
  mounted() {
    if (!auth) {
      console.warn("Firebase auth is not initialized");
      return;
    }

    onAuthStateChanged(auth, (user) => {
      if (this.subscribe) this.subscribe();

      if (user && user.uid) {
        this.currentUserId = user.uid;

        if (this.$options.name === "UserProfile") {
          setTimeout(() => {
            this.listenUsers();
          }, 2000);
        }
      } else {
        this.users = [];
        this.currentUserId = null;
      }
    });

    this.checkConfigAndAdminStatus();
  },
};
</script>

<style scoped></style>
